import { Injectable } from '@angular/core';
import {UserService} from '../user/user.service';
import {ResourcesService} from '../resources.service';
import {Widget} from '../../model/widget';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class WidgetService {

  constructor(private _resources: ResourcesService, private _user: UserService) { }

  getAll(): Observable<Widget[]> {
    return this._resources.get('Widget/AgentGetAll?agentId=' + this._user.userAccountTypeDefault.agentId);
  }

  delete(widget: Widget): Observable<Widget> {
    widget.agentId = this._user.userAccountTypeDefault.agentId;
    return this._resources.post('Widget/AgentDelete', widget);
  }

  create(widget: Widget): Observable<Widget> {
    widget.agentId = this._user.userAccountTypeDefault.agentId;
    return this._resources.post('Widget/AgentCreate', widget);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/widget/widget.service.ts